'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_ju_Locale$Category() {
  this.q = null;
  this.M = 0;
}
export { $c_ju_Locale$Category as $c_ju_Locale$Category };
$p = $c_ju_Locale$Category.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_ju_Locale$Category;
/** @constructor */
function $h_ju_Locale$Category() {
}
export { $h_ju_Locale$Category as $h_ju_Locale$Category };
$h_ju_Locale$Category.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
var $d_ju_Locale$Category = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "java.util.Locale$Category", ({
  ch: 1,
  n: 1,
  j: 1,
  a: 1,
  b: 1,
  c: 1,
  l: 1
}));
export { $d_ju_Locale$Category as $d_ju_Locale$Category };
